import { ExchangeScreen } from '@/features/exchange';

const ExchangePage = () => {
  return (
    <div className="w-full flex justify-center items-center tablet:-ml-[15rem] pt-[1.8rem] px-[2.4rem]">
      <ExchangeScreen />
    </div>
  );
};

export { ExchangePage };
